
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uyelik-sozlesmesi",
      function () {
        return require("private-next-pages/uyelik-sozlesmesi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uyelik-sozlesmesi"])
      });
    }
  